<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">DATA MANAGER</h4>
      <div
        slot="beforeFilter"
        class="custom-search d-flex">
        <b-button
          v-if="isAdmin"
          class="btn grey btn-import-form m__r--5"
          @click="$refs.modalAdd.show()">
          <i class="fa fa-plus fa-lg"/> Add
        </b-button>
        <b-form-input
          v-model="filter_data"
          placeholder="Search Table Group"
          style="width: 250px; height: 35px"/>
      </div>
    </div>

    <div class="studio-page-content">
      <h4 class="title-tab-experience-manager">TABLE GROUP</h4>

      <div
        v-if="showContainerGroup"
        class="row-group-studio">
        <div
          v-for="(item, index) in listGroup"
          :key="index"
          class="col-group-studio">
          <div class="data-group-container">
            <div class="d-flex">
              <img
                :src="require('@/assets/icon-sidebar/data-manager.svg')"
                width="35"
                @click="openDetail(item.id)">
              <div
                class="data-group-container__label ellipsis"
                @click="openDetail(item.id)">
                <i v-if="item.id === 'legacy'">{{ item.name }}</i>
                <b v-else>{{ item.name }}</b>
                <br>
                <div class="data-group-container__label-small">
                  Last edit at {{ convertDateTime(item.updated_at) }}
                </div>
              </div>
              <i
                v-if="item.id !== 'legacy'"
                :id="`configPopover-${item.id}`"
                class="fa fa-ellipsis-v fa-lg data-group-container__icon-config"
                @click="showPopoverComponent(item.id)"
              />

              <!-- Popover -->
              <b-popover
                v-click-outside="hideAllPopover"
                v-if="popoverSelected === item.id"
                :target="`configPopover-${item.id}`"
                :show.sync="showPopover"
                triggers="click blur"
                placement="bottom">
                <div
                  v-if="showContentPopover"
                  :class="{ 'disabled': isDisabledConfig}"
                  class="add-automation"
                  @click="openConfig(item)">Configuration</div>
                <div
                  v-if="isAdmin && showContentPopover"
                  class="add-automation"
                  @click="deleteData(item)">Delete</div>
                <div v-if="!showContentPopover">Please wait...</div>
              </b-popover>
            </div>
            <div
              class="data-group-container__count-dataset"
              @click="openDetail(item.id)">
              {{ item.total_table || 0 }}
              <small>table{{ item.total_table > 0 ? 's' : '' }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- <b-row v-if="showContainerGroup">
        <b-col
          v-for="(item, index) in listGroup"
          :key="index"
          xl="3"
          lg="4"
          md="4"
          sm="6">
          <div class="data-group-container">
            <div class="d-flex">
              <img
                :src="require('@/assets/icon-sidebar/data-manager.svg')"
                width="35"
                @click="openDetail(item.id)">
              <div
                class="data-group-container__label ellipsis"
                @click="openDetail(item.id)">
                <i v-if="item.id === 'legacy'">{{ item.name }}</i>
                <b v-else>{{ item.name }}</b>
                <br>
                <div class="data-group-container__label-small">
                  Last edit at {{ convertDateTime(item.updated_at) }}
                </div>
              </div>
              <i
                v-if="item.id !== 'legacy'"
                :id="`configPopover-${item.id}`"
                class="fa fa-ellipsis-v fa-lg data-group-container__icon-config"
                @click="showPopoverComponent(item.id)"
              />

              <b-popover
                v-click-outside="hideAllPopover"
                v-if="popoverSelected === item.id"
                :target="`configPopover-${item.id}`"
                :show.sync="showPopover"
                triggers="click blur"
                placement="bottom">
                <div
                  v-if="showContentPopover"
                  :class="{ 'disabled': isDisabledConfig}"
                  class="add-automation"
                  @click="openConfig(item)">Configuration</div>
                <div
                  v-if="isAdmin && showContentPopover"
                  class="add-automation"
                  @click="deleteData(item)">Delete</div>
                <div v-if="!showContentPopover">Please wait...</div>
              </b-popover>
            </div>
            <div
              class="data-group-container__count-dataset"
              @click="openDetail(item.id)">
              {{ item.total_table || 0 }}
              <small>table{{ item.total_table > 0 ? 's' : '' }}</small>
            </div>
          </div>
        </b-col>
      </b-row> -->

      <b-row
        v-else
        class="data-group-wrap-loading">
        <b-col
          v-for="i in 8"
          :key="i"
          xl="3"
          lg="4"
          md="4"
          sm="6">
          <div class="group-block" />
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalAdd"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="label-group-modal text-center">CREATE TABLE GROUP</div>
      <b-form-group :class="{'error-input' : $v.table_group_name.$error}">
        <label for="name"> Name </label>
        <j-input
          id="name"
          v-model="$v.table_group_name.$model"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_group"/>
      </b-form-group>
      <div class="float-right">
        <b-button
          class="btn white m__r--5"
          @click="closeModal">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="submitData">
          Create
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },
  data() {
    return {
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],

      table_group_id: 0,
      table_group_name: null,
      listGroup: [],
      popoverSelected: '',
      showPopover: false,
      showContentPopover: false,
      showContainerGroup: false,
      isDisabledConfig: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreForm', ['group_data_list']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },
  watch: {
    table_group_name(val) {
      if (val) {
        const regexSymbol = /[^\w\s]/g;
        setTimeout(() => {
          this.table_group_name =
            val.toLowerCase()
              .replace(regexSymbol, '')
              .replace(' ', '_');
        }, 1);
      }
    },

    filter_data(val) {
      this.listGroup = this.group_data_list.filter(app => app.name.toUpperCase().includes(val.toUpperCase()) || app.id.toUpperCase().includes(val.toUpperCase()));
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    ...mapActions('jStoreForm', ['getListDataGroup', 'createDataGroup', 'deleteDataGroup', 'getListPrivilegeByMe']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo', 'toggleProblem']),

    getListData() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        search: '',
      };
      this.getListDataGroup(req).then((res) => {
        if (!res.error) {
          this.listGroup = res.data || [];
          this.showContainerGroup = true;
        }
      });
    },

    showPopoverComponent(id) {
      this.isDisabledConfig = true;
      this.showContentPopover = false;
      if (id !== this.popoverSelected) {
        this.popoverSelected = id;
        this.showPopover = true;
        this.getListPrivilegeByMe({ tablegroup_id: id }).then((res) => {
          if (!res.error) {
            if ((res.data && res.data.privilege.includes('moderator') && !res.data.privilege.includes('view_only')) || this.isAdmin) {
              this.isDisabledConfig = false;
            }
            this.showContentPopover = true;
          }
        });
      } else {
        this.hideAllPopover();
      }
    },

    hideAllPopover() {
      this.popoverSelected = '';
      this.showPopover = false;
    },

    openConfig(data) {
      if (!this.isDisabledConfig) {
        this.$router.push(`/form-data/table-config/${data.id}`);
      }
    },

    closeModal() {
      this.$refs.modalAdd.hide();
      this.table_group_id = 0;
      this.table_group_name = null;
      setTimeout(() => { this.$v.table_group_name.$reset(); }, 500);
    },

    submitData() {
      this.$v.table_group_name.$touch();
      if (!this.$v.table_group_name.$error) {
        this.createDataGroup({ name: this.table_group_name }).then((res) => {
          if (!res.error && res.error_session) {
            this.toggleInfo(res.message);
          } else if (!res.error && !res.error_session) {
            this.openDetail(res.data.id);
          } else {
            this.toggleProblem(res.message);
          }
        });
      }
    },

    openDetail(id) {
      this.$router.push(`/form-data/table/${id}`);
    },

    deleteData(data) {
      this.$root.$emit('bv::hide::popover', `configPopover-${data.id}`);
      if (data.total_table === 0) {
        const text = 'Are you sure want to delete Table Group?';

        this.$swal({
          title: 'Delete',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.deleteDataGroup({ id: data.id }).then((res) => {
              if (!res.error && res.error_session) {
                this.toggleInfo(res.message);
              } else if (!res.error && !res.error_session) {
                this.getListData();
              } else {
                this.toggleProblem(res.message);
              }
            });
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Table Already Exist, Can’t Delete Table Group');
      }
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
  validations() {
    return {
      table_group_name: { required },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/data-manager/jFormGroup.vue